import script from "./PointChargeFail.vue?vue&type=script&setup=true&lang=js"
export * from "./PointChargeFail.vue?vue&type=script&setup=true&lang=js"

import "./PointChargeFail.vue?vue&type=style&index=0&id=2c6017ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6017ad"]])

export default __exports__